import EmojiWindow from "components/EmojiWindow/EmojiWindow";
import { __callbacks } from "Utils/Callbacks/Callback";
import { useCallback, useEffect, useRef, useState } from "react";
import Input from "../Input/Input";
import styles from "./Footer.module.scss";
import { __chats } from "Utils/Chats/Chats";

export default function Footer({ chatId }) {  // Now receiving chatId as prop
    const btnFileUpload = useRef(null);
    const [classBtnSendHide, setClassBtnSendHide] = useState(styles["btn-disabled"]);
    const [showEmojiWindow, setShowEmojiWindow] = useState(false);
    const [classEmojiActive, setClassEmojiActive] = useState("");
    const [isBotConversation, setIsBotConversation] = useState(false);

    const emojiWindow = useCallback(
        (show = true) => {
            if (show) {
                setShowEmojiWindow(true);
                setClassEmojiActive("config-icon-footer-active")
            }
            else {
                setShowEmojiWindow(false);
                setClassEmojiActive("");
            }
        },
        [],
    );

    const initListeners = useCallback(
        () => {
            btnFileUpload?.current.addEventListener("change", e => {
                const file = btnFileUpload?.current.files[0];
                if (!file) return;
                const size = file.size;
                const isSizeValid = ((size / 1024 / 1024) <= 2);
                if (!isSizeValid) {
                    __callbacks.userNotification.trigger("The file size is too large! Maximum 2mb is allowed.");
                    return;
                }
                __callbacks.fileUpload.trigger(btnFileUpload?.current.files[0]);
            });

            __callbacks.onStartNewChat(() => {
                btnFileUpload.current.value = "";
                emojiWindow(false);
            });
            __callbacks.onContinueConversation(() => {
                btnFileUpload.current.value = "";
                emojiWindow(false);
            });
            __callbacks.onEmojiWindow(data => {
                emojiWindow(data.show);
            });

        },
        [btnFileUpload, emojiWindow],
    );

    useEffect(() => {
        __callbacks.onChatSendButton(data => {
            if (data.enable) {
                setClassBtnSendHide("");
            }
            else {
                setClassBtnSendHide(styles["btn-disabled"]);
            }
        });

        initListeners();
    }, [initListeners]);

    const onChatSendButtonClick = () => {
        __callbacks.chatSendButtonClick.trigger({});
    }

    const onFileUploadClick = () => {
        btnFileUpload?.current.click();
    }

    const onEmojiClick = () => {
        setShowEmojiWindow(val => {
            if (val) {
                setClassEmojiActive("");
            }
            else {
                setClassEmojiActive("config-icon-footer-active");
            }
            return !val;
        });
    }

    return (
        <div className={styles.container}>
            <div className={styles["container-chat-input"]}>
                <Input></Input>
            </div>
            <div className={styles["container-content"]}>
                <div className={`${styles.icon} ${classBtnSendHide} config-icon-footer`} onClick={onChatSendButtonClick}>
                    <svg xmlns="http://www.w3.org/2000/svg" width="15" height="16" viewBox="0 0 15 16" fill="none">
                        <path d="M1.40362 15.3409C0.417688 15.8509 -0.180418 15.3951 0.0683394 14.3202L1.08878 9.91078C1.21312 9.37347 1.75105 8.88843 2.30788 8.82543L8.50342 8.12441C10.1512 7.93797 10.157 7.63892 8.50342 7.455L2.30788 6.76592C1.75893 6.70487 1.21294 6.21784 1.08878 5.67988L0.0683394 1.25866C-0.18014 0.182085 0.408942 -0.281766 1.40362 0.232725L14.223 6.86346C15.209 7.37342 15.2177 8.19572 14.223 8.71021L1.40362 15.3409Z" fill="gray" className={`${styles["svg-btn-send-path"]} config-svg-btn-send-path`} />
                    </svg>
                </div>
                {!isBotConversation && (
                    <>
                        <div onClick={onEmojiClick} className={`${styles.icon} ${styles["icon-emoji"]} config-icon-footer ${classEmojiActive}`}>
                            <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 18 18" fill="none">
                                <path fillRule="evenodd" clipRule="evenodd" d="M9 0C11.3869 0 13.6761 0.948212 15.364 2.63604C17.0518 4.32387 18 6.61305 18 9C18 11.3869 17.0518 13.6761 15.364 15.364C13.6761 17.0518 11.3869 18 9 18C6.61305 18 4.32387 17.0518 2.63604 15.364C0.948212 13.6761 0 11.3869 0 9C0 6.61305 0.948212 4.32387 2.63604 2.63604C4.32387 0.948212 6.61305 0 9 0V0ZM9 1C4.589 1 1 4.589 1 9C1 13.411 4.589 17 9 17C13.411 17 17 13.411 17 9C17 4.589 13.411 1 9 1ZM5 6.999C5.00053 6.73352 5.1065 6.47912 5.2946 6.29177C5.38774 6.19901 5.49823 6.12549 5.61978 6.07543C5.74133 6.02537 5.87155 5.99974 6.003 6C6.13445 6.00026 6.26457 6.02641 6.38591 6.07696C6.50726 6.12751 6.61746 6.20146 6.71023 6.2946C6.80299 6.38774 6.87651 6.49823 6.92657 6.61978C6.97663 6.74133 7.00226 6.87155 7.002 7.003C7.00147 7.26848 6.8955 7.52288 6.7074 7.71023C6.5193 7.89758 6.26448 8.00253 5.999 8.002C5.73352 8.00147 5.47912 7.8955 5.29177 7.7074C5.10442 7.5193 4.99947 7.26448 5 6.999V6.999ZM10.999 6.999C11.013 6.74312 11.1245 6.50234 11.3106 6.32617C11.4967 6.14999 11.7432 6.05181 11.9995 6.05181C12.2558 6.05181 12.5023 6.14999 12.6884 6.32617C12.8745 6.50234 12.986 6.74312 13 6.999C13 7.26435 12.8946 7.51883 12.707 7.70646C12.5193 7.89409 12.2648 7.9995 11.9995 7.9995C11.7342 7.9995 11.4797 7.89409 11.292 7.70646C11.1044 7.51883 10.999 7.26435 10.999 6.999V6.999ZM8.959 13.5C8.873 13.5 8.786 13.498 8.699 13.493C6.259 13.361 4.675 11.394 4.609 11.311L4.299 10.919L5.08 10.299L5.392 10.689C5.406 10.706 6.774 12.392 8.762 12.495C10.068 12.567 11.372 11.941 12.644 10.649L12.995 10.293L13.707 10.995L13.357 11.351C11.95 12.778 10.471 13.501 8.959 13.501V13.5Z" fill="gray" />
                            </svg>
                        </div>
                        <div className={`${styles.icon} ${styles["icon-upload"]} config-icon-footer`} onClick={onFileUploadClick}>
                            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="18" viewBox="0 0 16 18" fill="none">
                                <path fillRule="evenodd" clipRule="evenodd" d="M14.1544 6.9185L14.1504 6.9215L14.1514 6.9175L10.8644 10.2035L10.8584 10.1985L7.28438 13.7725C7.26838 13.7895 7.25438 13.8085 7.23638 13.8255L7.18638 13.8725L7.14338 13.9135V13.9115C5.97638 14.9815 4.45138 15.2425 3.32038 14.1115C2.19038 12.9815 2.43038 11.4345 3.50038 10.2685L3.49538 10.2645L3.56938 10.1915L3.58538 10.1735C3.59138 10.1685 3.59738 10.1645 3.60238 10.1575L9.65538 4.1045L10.4164 4.8645L4.36338 10.9185L4.33438 10.9465V10.9475L4.32938 10.9515L4.25638 11.0255C4.26738 11.0155 4.28138 11.0075 4.29138 10.9955C3.60338 11.7455 3.36138 12.6315 4.08138 13.3515C4.80138 14.0715 5.66438 13.8075 6.41438 13.1195L6.38438 13.1535L6.42438 13.1115L6.43438 13.1035L6.44238 13.0945L6.47538 13.0645L6.50638 13.0305L6.51638 13.0215L6.52338 13.0125L11.5274 8.0095L11.5324 8.0155L13.3904 6.1565C14.6134 4.9385 14.9004 3.2435 13.6814 2.0245C12.4624 0.806498 10.4144 0.740498 9.19538 1.9585L2.24838 8.9055C2.25138 8.9055 2.25438 8.9035 2.25638 8.9015C0.631382 10.5685 0.714382 13.3315 2.35938 14.9755C4.00538 16.6215 6.83338 16.7705 8.50038 15.1455C8.49738 15.1475 8.49638 15.1535 8.49238 15.1575L8.53938 15.1105L14.5924 9.0565L14.6344 9.0145L15.3774 9.7945L15.3524 9.8155L15.3534 9.8175L9.30338 15.8675L9.30138 15.8695L9.29938 15.8705L9.25338 15.9165H9.25138C7.15738 17.9565 3.67338 17.8105 1.59938 15.7365C-0.449618 13.6875 -0.550618 10.3295 1.41638 8.2315L1.41038 8.2265H1.40838L1.48438 8.1485L8.42738 1.2045L8.43038 1.2025L8.43438 1.1975C10.0754 -0.442502 12.8014 -0.376502 14.4424 1.2635C16.0824 2.9055 15.7954 5.2775 14.1544 6.9185V6.9185Z" fill="gray" />
                            </svg>
                            <input ref={btnFileUpload} type="file" name="file-upload" id="" hidden />
                        </div>
                    </>
                )}
            </div>
            {showEmojiWindow && (
                <div className={styles["container-window-emoji"]}><EmojiWindow /></div>
            )}
        </div>
    );
}
